<template>
  <div>
    <div class="text-center flex justify-center">
      <div class="text-center mt-4 w-10/12">
          <SidebarTitle icon="Edit3Icon" title="title" />
          <vs-input
              label=""
              v-model="goal.title"
              name="title"
              class="w-full"
              autocomplete="off"
              ref="titleInput"
              @keyup.enter.native.stop="save"
          />
       </div>
    </div>

    <ColorPicker v-model="goal.backgroundColor" class="mt-8"/>

    <RelatedAreas :key="`goal-RA-${editedEntity.id}`" class="mt-8" v-model="goal.relatedAreas" :m="goal" />


    <div class="mt-8">
      <div class="text-center">
      <SidebarLabel class="text-center" title="target" icon="TargetIcon" />
      </div>

    <div v-if="goalTargetPickerOpen">
      <div class="flex justify-center" >
       <div class="mt-2">
          <vs-radio key="percentages" vs-name="percentages" color="dark" class="mx-3" v-model="goal.targetValueType" vs-value="percentages">100%</vs-radio>
          <vs-radio key="custom" vs-name="custom" color="dark" class="mx-3" v-model="goal.targetValueType" vs-value="custom">custom</vs-radio>
       </div>
      </div>
      <div v-if="customUnits" class="flex justify-center mt-2">
        <div>
          <vs-input-number :disabled="percentages" color="dark" v-model="goal.max" label="" min="1" @keyup.enter.native="save"/>
        </div>

          <vs-input placeholder="$, kg, km, ..." color="dark" class="ml-4 w-32" v-model="goal.customUnitsText" @keyup.enter.native="save"/>
      </div>
    </div>


        <div v-else class="flex justify-center text-dark items-center" :class="actionElementCss" @click="goalTargetPickerOpen = true">

        {{targetInWords}}

        <feather-icon  icon="EditIcon" class="ml-1 w-4 cursor-pointer"  />
      </div>
    </div>


    <DeadlinePicker v-model="deadlineRaw" class="mt-8" :goalMetadates="true" :showPickerInitially="!edit"/>

    <Editor v-model="goal.notes"/>

      <DiveDeeper>
        <DiveDeeperItem title="why is this important to me?" v-model="goal.whyDescription"/>

        <DiveDeeperItem title="what would I gain by achieving this?" v-model="goal.gainDescription"/>

        <DiveDeeperItem title="what are possible risks and obstacles?" v-model="goal.riskDescription"/>
      </DiveDeeper>

      <MakeIt title="make it stick">

        <Checkbox :key="`${$vnode.key}-specific`" :namespace="`${$vnode.key}-specific`" class="mt-3" initValue="specific" title="is it specific?" v-model="goal.makeIt" />

        <div class="flex text-center text-sm">
          What is the direction and meaning of the goal I’m pursuing? Example: I want to lose 50 pounds.
        </div>


        <Checkbox :key="`${$vnode.key}-measurable`" :namespace="`${$vnode.key}-measurable`" class="mt-3" initValue="measurable" title="is it measurable?" v-model="goal.makeIt" />

        <div class="flex text-center text-sm">
          Will the goal be able to be measured? Example: Every week I will weigh in and measure my progress.

        </div>


        <Checkbox :key="`${$vnode.key}-attainable`" :namespace="`${$vnode.key}-attainable`" class="mt-3" initValue="attainable" title="is it attainable?" v-model="
        goal.makeIt" />
        <div class="flex text-center text-sm">
          Is the goal realistic? Example: I have spare time and money to devote to losing weight.

        </div>

        <Checkbox :key="`${$vnode.key}-relevant`" :namespace="`${$vnode.key}-relevant`" class="mt-3" initValue="relevant" title="is it relevant?" v-model="goal.makeIt" />
        <div class="flex text-center text-sm">
          Does the goal align with my inner self? Example: Yes, I want to look good during the summer.

        </div>

        <Checkbox :key="`${$vnode.key}-time-bound`" :namespace="`${$vnode.key}-time-bound`" class="mt-3" initValue="time-bound" title="is it time-bound?" v-model="goal.makeIt" />
        <div class="flex text-center text-sm">
          When will the goal need to be met? Example: I have a year to lose 50 pounds.
        </div>

        </MakeIt>

    <InfoCard v-if="false" title="short-term & measurable">
      <p class="mb-3">Goal ‑ something you want to achieve soon or in the near future (up to 1 year) and usually requires a series of tasks and routines to be accomplished. Goals can also be your personal metrics for your continuous progress.</p>
      <p class="mb-3 font-bold">Goals don't work unless you do.</p>

      <p class="italic">„Always remember, your focus determines your reality.“ — George Lucas.</p>
    </InfoCard>
  </div>
</template>
<script>
import _ from 'lodash'
import MonthSelect from '../Generic/MonthSelect'
import DreamSelect from '../Dreams/Select'
import trackAnalytics from '@/helpers/trackAnalytics'
import { computeProgressPercent } from '@/models/Goal'
import flatPickr from 'vue-flatpickr-component'
import * as DateHelper from '@/helpers/date'
import * as Common from '@/helpers/common'
import ColorPicker from '@/views/Self-Improvee/Generic/ColorPicker'
import { midnight, formatyyymmdd, isMetadate, parseInCurrentTimezone } from '@/helpers/date'
import DiveDeeper from '@/views/Self-Improvee/Planner/DiveDeeper'
import DiveDeeperItem from '@/views/Self-Improvee/Planner/DiveDeeperItem'

export default {
  components: {
    MonthSelect,
    DreamSelect,
    flatPickr,
    ColorPicker,
    DiveDeeper,
    DiveDeeperItem
  },
  props: {
    editedEntity: {
      type: Object,
      required: false,
      default: () => {}
    },
    planningMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dreamMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data () {
    return {
      goal: {},
      goalTargetPickerOpen: false,
      deadlineRaw: null,
      deadline: null,
      dreamId: null,
      showCalendar: false,
      configInlineDateTimePicker: {
        disableMobile: false,
        parseDate: (datestr) => DateHelper.midnight(new Date(datestr)),
        inline: true,
        altInput: true, // optional
        altInputClass: 'hide-me',  // optional
        // wrap: true,
        locale: { firstDayOfWeek: 1 }
      },
      // configInlineDateTimePicker: {
      //   disableMobile: false,
      //   parseDate: (datestr) => DateHelper.midnight(new Date(datestr)),
      //   locale: { firstDayOfWeek: 1 }
      // },
    }
  },
  watch: {
    editedEntity: {
      immediate: true,
      async handler (editedEntity) {
        if (!editedEntity) return
        this.deadlineRaw = ''
        this.goal = _.merge({}, this.goalDefaults, editedEntity)
        this.showCalendar = false

        if (!this.goal.targetValueType) {
          this.goal.targetValueType = (this.goal.max == 100) ? 'percentages' : 'custom'
        }

        if (editedEntity) {
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }

        if (!editedEntity.id && this.$store.getters.isLargeScreen) {
          this.$forceNextTick(() => this.$refs['titleInput'].focusInput())
        }


        if (this.goal.deadline) {
          if (this.edit) {
            this.deadlineRaw = formatyyymmdd(this.goal.deadline.toDate())
          } else {
            this.deadlineRaw = formatyyymmdd(this.goal.deadline)
          }
        } else {
          this.deadlineRaw = this.goal.showList
        }
      }
    },
    targetValueType: {
      immediate: false,
      async handler (targetValueType) {
        if (this.percentages) {
          this.goal.max = 100
        }
      }
    }
  },
  computed: {
    targetInWords () {
      if (this.percentages) {
        return '100%'
      } else {
        return `${this.goal.max} ${this.goal.customUnitsText}`
      }
    },
    customUnits () {
      return this.targetValueType === 'custom'
    },
    percentages () {
      return this.targetValueType === 'percentages'
    },
    targetValueType () {
      return this.goal.targetValueType
    },
    goalDefaults () {
      return {
        dreamId: this.singleDreamId,
        max: 100,
        backgroundColor: '',
        targetValueType: '',
        progressesData: [],
        customUnitsText: '',
        relatedAreas: [],
        whyDescription: '',
        gainDescription: '',
        riskDescription: '',
        makeIt: [],
        notes: '',
      }
    },
    validateForm () {
      return !this.errors.any()
    },
    promptActive () {
      return !!this.editedEntity
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
    singleDreamId () {
      const dreams = this.$store.getters.dreams
      return dreams.length === 1 ? dreams[0].id : null
    },
    hasSubgoals () {
      return false
      // if (this.editedEntity) {
      // return this.$store.getters.anySubgoalsByGoalId(this.editedEntity.id)
      // }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then((result) => {
        if (!result) return


        if (this.deadlineRaw) {
          if (isMetadate(this.deadlineRaw)) {
            this.goal.deadline = null
            this.goal.showList = this.deadlineRaw
          } else {
            this.goal.deadline = parseInCurrentTimezone(this.deadlineRaw)
          }
        } else {
          this.goal.deadline = null
        }

        const progress = this.goal.progress > this.goal.max ? this.goal.max : this.goal.progress
        const progressPercent = computeProgressPercent({
          currentProgress: this.goal.progress, max: this.goal.max
        })

        if (this.edit) {
          const doneOn = progressPercent === 100 ? DateHelper.midnight() : null
          const {title, deadline, max, dreamId, backgroundColor, customUnitsText, targetValueType, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes } = this.goal

          this.$store.dispatch('UPDATE_GOAL',
            {
              goal: this.editedEntity,
              updateFields: {title, deadline: Common.ensureNull(deadline), max, dreamId: Common.ensureNull(dreamId), progressPercent, progress, backgroundColor, doneOn, customUnitsText, targetValueType, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes }
            })
        } else {
          this.$store.dispatch('ADD_GOAL', { goal: this.goal })
        }

        trackAnalytics(this, 'app_action', this.edit ? 'update_goal' : 'add_goal', null, this.$store.getters.daysFromRegistration)
        this.close()
      })
    },
  },
  beforeDestroy () {
    this.$root.$off('goalSidebarFooterSaveClicked')
  },
  mounted () {
    this.$root.$on('goalSidebarFooterSaveClicked', () => {
      this.save()
    })
  },
}
</script>
